import { aulas_inicio } from "../utils/YEARCONSTS";
import { logDebug } from "../utils/logger";
import * as sponteEndpoints from './endpoints/sponte';

/**
 * API proxy para Sponte
 * Todas as chamadas agora são feitas via backend para proteger tokens sensíveis
 * Tokens e códigos de cliente nunca são expostos no frontend
 */

// Manter compatibilidade com código existente
export const api = null; // Não usado mais, mas mantido para compatibilidade

export const getAllStudents = async (anoLetivo, situacaoID = 1) => {
  try {
    return await sponteEndpoints.getAllStudents(anoLetivo, situacaoID);
  } catch (error) {
    logDebug("getAllStudents=> ", error);
    return [];
  }
};
export const getStudentByName = async (name) => {
  try {
    return await sponteEndpoints.getStudentByName(name);
  } catch (error) {
    logDebug("getStudentByName=> ", error);
    return [];
  }
};

export const searchStudentsByName = async (name) => {
  try {
    return await sponteEndpoints.searchStudentsByName(name);
  } catch (error) {
    logDebug("searchStudentsByName=> ", error);
    return [];
  }
};

// Nova função para buscar dados completos do aluno pelo nome
export const getStudentCompleteByName = async (name) => {
  try {
    const response = await sponteEndpoints.getStudentCompleteByName(name);
    logDebug("getStudentCompleteByName=> ", response);
    return response;
  } catch (error) {
    logDebug("getStudentCompleteByName=> ", error);
    return null;
  }
};

export const getResponsables = async (idSponte) => {
  try {
    return await sponteEndpoints.getResponsables(idSponte);
  } catch (error) {
    console.error("Erro na API:", error);
    return [];
  }
};

// Nova função para obter informações completas dos responsáveis
export const getResponsableInfo = async (idSponte, selectedStudentId) => {
  try {
    return await sponteEndpoints.getResponsableInfo(idSponte, selectedStudentId);
  } catch (error) {
    console.error("Erro na API:", error);
    return null;
  }
};

export const getAllClassrooms = async (anoLetivo) => {
  try {
    return await sponteEndpoints.getAllClassrooms(anoLetivo);
  } catch (error) {
    logDebug("getAllClassrooms=> ", error);
    return [];
  }
};

export const getStudentsByClassroom = async (TurmaID) => {
  try {
    return await sponteEndpoints.getStudentsByClassroom(TurmaID);
  } catch (error) {
    logDebug("getStudentsByClassroom=> ", error);
    return [];
  }
};

export const getSubjects = async (TurmaID) => {
  try {
    return await sponteEndpoints.getSubjects(TurmaID);
  } catch (error) {
    logDebug("getSubjects=> ", error);
    return [];
  }
};

export const getPartialGrades = async (
  TurmaID,
  AlunoID,
  DisciplinaID,
  period
) => {
  try {
    return await sponteEndpoints.getPartialGrades(TurmaID, AlunoID, DisciplinaID, period);
  } catch (error) {
    logDebug("getPartialGrades=> ", error);
    return {};
  }
};

export const setPartialGrades = async (grades, avaliacao, nota) => {
  try {
    return await sponteEndpoints.setPartialGrades(grades, avaliacao, nota);
  } catch (error) {
    logDebug("setPartialGrades=> ", error);
    throw error;
  }
};
export const setFinalGrades = async (grades, nota) => {
  try {
    return await sponteEndpoints.setFinalGrades(grades, nota);
  } catch (error) {
    logDebug("setFinalGrades=> ", error);
    throw error;
  }
};

export const getStudentsAndResponsablesByClassroom = async (classromsList) => {
  try {
    return await sponteEndpoints.getStudentsAndResponsablesByClassroom(classromsList);
  } catch (error) {
    logDebug("getStudentsAndResponsablesByClassroom=> ", error);
    return [];
  }
};

export const getGradesBySubject = async (AlunoID, TurmaID, DisciplinaID) => {
  try {
    return await sponteEndpoints.getGradesBySubject(AlunoID, TurmaID, DisciplinaID);
  } catch (error) {
    logDebug("getGradesBySubject=> ", error);
    return {};
  }
};

export const getGradesBySubjectBatch = async (AlunoIDs, TurmaID, DisciplinaID) => {
  try {
    return await sponteEndpoints.getGradesBySubjectBatch(AlunoIDs, TurmaID, DisciplinaID);
  } catch (error) {
    logDebug("getGradesBySubjectBatch=> ", error);
    // Se for erro de rate limit, propagar o erro para que o componente possa tratá-lo
    if (error.response?.status === 429 || error.rateLimitExceeded) {
      throw error; // Re-lançar o erro para ser tratado no componente
    }
    // Para outros erros, retornar objeto vazio para não quebrar a UI
    return { data: {}, errors: {}, stats: { total: 0, success: 0, failed: 0 } };
  }
};

export const getStudentByID = async (AlunoID) => {
  try {
    return await sponteEndpoints.getStudentByID(AlunoID);
  } catch (error) {
    logDebug("getStudentByID=> ", error);
    return "";
  }
};

// Retorna o objeto completo do aluno para o Censo (não altera a função existente)
export const getStudentByIDCenso = async (AlunoID) => {
  try {
    return await sponteEndpoints.getStudentByIDCenso(AlunoID);
  } catch (error) {
    logDebug("getStudentByIDCenso=> ", error);
    return null;
  }
};

// Busca dados completos de múltiplos alunos (batch)
export const getStudentByIDCensoBatch = async (AlunoIDs, forceRefresh = false) => {
  try {
    return await sponteEndpoints.getStudentByIDCensoBatch(AlunoIDs, forceRefresh);
  } catch (error) {
    logDebug("getStudentByIDCensoBatch=> ", error);
    // Se for erro de rate limit, propagar o erro para que o componente possa tratá-lo
    if (error.response?.status === 429 || error.rateLimitExceeded) {
      throw error;
    }
    return { data: {}, errors: {}, stats: { total: 0, success: 0, failed: 0 } };
  }
};

export const getAllPreMatriculas = async () => {
  try {
    return await sponteEndpoints.getAllPreMatriculas(aulas_inicio);
  } catch (error) {
    logDebug("getAllPreMatriculas=> ", error);
    return [];
  }
};


export const setUpdateStudents = async (AlunoID, student, completeSummary, enrollmentContractStatus) => {
  try {
    return await sponteEndpoints.setUpdateStudents(AlunoID, student, completeSummary, enrollmentContractStatus);
  } catch (error) {
    logDebug("setUpdateStudents=> ", error);
    throw error;
  }
};

export const setEnrollmentPaymentOption = async (AlunoID, paymentOption, options) => {
  try {
    return await sponteEndpoints.setEnrollmentPaymentOption(AlunoID, paymentOption, options);
  } catch (error) {
    logDebug("setEnrollmentPaymentOption=> ", error);
    throw error;
  }
};

export const setEnrollmentContractStatus = async (AlunoID, options) => {
  try {
    return await sponteEndpoints.setEnrollmentContractStatus(AlunoID, options);
  } catch (error) {
    logDebug("setEnrollmentContractStatus=> ", error);
    throw error;
  }
};

export const setUpdateFather = async (father) => {
  try {
    return await sponteEndpoints.setUpdateFather(father);
  } catch (error) {
    logDebug("setUpdateFather=> ", error);
    throw error;
  }
};

export const setUpdateMother = async (mother) => {
  try {
    return await sponteEndpoints.setUpdateMother(mother);
  } catch (error) {
    logDebug("setUpdateMother=> ", error);
    throw error;
  }
};

export const getAllMatriculas = async (DataInicio, SituacaoID, schoolYear) => {
  try {
    return await sponteEndpoints.getAllMatriculas(DataInicio, SituacaoID, schoolYear);
  } catch (error) {
    logDebug("getAllMatriculas=> ", error);
    throw error;
  }
};

export const getEnrollmentContractStatuses = async (schoolYear, studentIds = []) => {
  try {
    return await sponteEndpoints.getEnrollmentContractStatuses(schoolYear, studentIds);
  } catch (error) {
    logDebug("getEnrollmentContractStatuses=> ", error);
    throw error;
  }
};

export const getResponsavelFinanceiro = async (AlunoID) => {
  try {
    return await sponteEndpoints.getResponsavelFinanceiro(AlunoID);
  } catch (error) {
    logDebug("getResponsavelFinanceiro=> ", error);
    return [];
  }
};

// Busca responsável financeiro de múltiplos alunos (batch)
export const getResponsavelFinanceiroBatch = async (AlunoIDs, forceRefresh = false) => {
  try {
    return await sponteEndpoints.getResponsavelFinanceiroBatch(AlunoIDs, forceRefresh);
  } catch (error) {
    logDebug("getResponsavelFinanceiroBatch=> ", error);
    // Se for erro de rate limit, propagar o erro para que o componente possa tratá-lo
    if (error.response?.status === 429 || error.rateLimitExceeded) {
      throw error;
    }
    throw error;
  }
};

export const getFinanceiroByContract = async (ContratoID) => {
  try {
    return await sponteEndpoints.getFinanceiroByContract(ContratoID);
  } catch (error) {
    logDebug("getFinanceiroByContract=> ", error);
    return [];
  }
};

/**
 * Busca financeiro por múltiplos contratos (batch com rate limiting)
 * @param {Array<number|string>} ContratoIDs - Array de IDs de contratos
 * @returns {Promise<Object>} Objeto com ContratoID como chave e dados financeiros como valor
 */
export const getFinanceiroByContractsBatch = async (ContratoIDs, forceRefresh = false) => {
  try {
    return await sponteEndpoints.getFinanceiroByContractsBatch(
      ContratoIDs,
      forceRefresh
    );
  } catch (error) {
    logDebug("getFinanceiroByContractsBatch=> ", error);
    throw error;
  }
};

/**
 * Atualiza situação de múltiplos contratos em batch (processamento em lotes)
 * @param {Array<number|string>} ContratoIDs - Array de IDs de contratos
 * @param {number} SituacaoID - ID da situação (1=Vigente, 6=Pré-Matrícula, etc.)
 * @returns {Promise<Object>} Objeto com resultados e estatísticas
 */
export const setAllContractsBatch = async (ContratoIDs, SituacaoID) => {
  try {
    return await sponteEndpoints.setAllContractsBatch(ContratoIDs, SituacaoID);
  } catch (error) {
    logDebug("setAllContractsBatch=> ", error);
    // Se for erro de rate limit, propagar o erro para que o componente possa tratá-lo
    if (error.response?.status === 429 || error.rateLimitExceeded) {
      throw error;
    }
    throw error;
  }
};
